import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useCustomNavigation = () => {
  const navigate = useNavigate();
  const performNavigation = useCallback(
    (to, options) => {
      if (typeof to === 'number') navigate(to);
      else navigate(to, options);
    },
    [navigate]
  );

  return performNavigation;
};

export default useCustomNavigation;
